import React from 'react';
import './FormField.css';

interface SelectOption {
  value: string | number;
  label: string;
}

interface SelectFieldProps {
  label: string;
  name: string;
  value: string | number | '';
  onChange: (value: string | number) => void;
  onBlur?: () => void;
  onValidate?: (fieldName: string, value: any, isRequired: boolean) => void;
  required?: boolean;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  options: SelectOption[];
  isLoading?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  onValidate,
  required = false,
  placeholder = 'Select an option',
  error,
  disabled = false,
  options,
  isLoading = false,
}) => {
  const handleBlur = () => {
    if (onValidate) {
      onValidate(name, value, required);
    }
    if (onBlur) {
      onBlur();
    }
  };

  const handleChange = (newValue: string) => {
    const parsedValue = newValue === '' ? '' : (isNaN(Number(newValue)) ? newValue : Number(newValue));
    onChange(parsedValue);
    // Clear error on change (real-time validation)
    if (error && onValidate) {
      setTimeout(() => {
        onValidate(name, parsedValue, required);
      }, 100);
    }
  };

  return (
    <div className={`form-question ${error ? 'has-error' : ''}`}>
      <label htmlFor={name} className="question-label">
        {label} {required && <span className="required">*</span>}
      </label>
      <select
        id={name}
        name={name}
        className={`form-input ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
        value={value || ''}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={handleBlur}
        required={required}
        disabled={disabled || isLoading}
        aria-describedby={error ? `${name}-error` : undefined}
        style={{
          width: '100%',
          padding: '12px',
          border: error ? '2px solid #FF0000' : '1px solid #ddd',
          borderRadius: '8px',
          fontSize: '1rem',
          fontFamily: 'inherit',
          backgroundColor: disabled || isLoading ? '#f5f5f5' : '#fff',
          cursor: disabled || isLoading ? 'not-allowed' : 'pointer',
        }}
      >
        <option value="">{isLoading ? 'Loading...' : placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <span className="error-message" id={`${name}-error`} role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default SelectField;











